<template>
  <div class="camera-equ">
    <div class="camera-equ-top">
      <el-button class="addMerchants" @click="addMerchants()"
        >供应商管理</el-button
      >
      <el-button class="addPileTemplate" @click="addPileTemplate()"
        >新建模板</el-button
      >
      <div style="clear: both"></div>
    </div>
    <div class="camera-equ-table">
      <el-table
        :header-cell-style="{
          background: '#f3f3f3',
          color: '#323232',
          height: '50px',
        }"
        :data="tableData"
        border
        style="width: 100%"
      >
        <el-table-column prop="template_name" label="模板名称">
          <template slot-scope="scope">{{
            scope.row.template_name | defaultValFilter
          }}</template>
        </el-table-column>
        <el-table-column prop="maker_name" label="桩供应商">
          <template slot-scope="scope">{{
            scope.row.maker_name | defaultValFilter
          }}</template>
        </el-table-column>
        <el-table-column prop="create_time" label="创建时间">
          <template slot-scope="scope">{{
            scope.row.create_time | defaultValFilter
          }}</template>
        </el-table-column>
        <el-table-column label="操作" width="">
          <template slot-scope="scope">
            <el-button class="btn edit" @click="editCamera(scope.row)"
              >编辑</el-button
            >
            <el-button class="btn edit" @click="editCamera(scope.row, 2)"
              >详情</el-button
            >
            <el-button class="btn delete" @click="deleteCamera(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <el-pagination
        background
        layout="prev, pager, next"
        :page-size="10"
        @current-change="currentChange"
        :total="totalNum"
      >
      </el-pagination>
    </div>
    <!-- 新建/编辑模板 -->
    <el-dialog
      :visible.sync="addCameraDialog"
      customClass="camera-dialog"
      width="820px"
      :close-on-click-modal="false"
    >
      <p class="title">{{ cameraTitle }}</p>
      <div class="line"></div>
      <div>
        <el-row>
          <el-col :span="4">
            <span>*</span>
            <span>模板名称：</span>
          </el-col>
          <el-col :span="8">
            <el-input
              :disabled="ifdis == true"
              v-model="templateName"
              clearable
              placeholder="请输入模板名称"
            ></el-input>
          </el-col>
          <el-col :span="4">
            <span>*</span>
            <span>桩供应商：</span>
          </el-col>
          <el-col :span="8">
            <el-select
              v-model="pileGav"
              clearable
              :disabled="ifdis == true"
              placeholder="请选择桩供应商"
            >
              <el-option
                v-for="item in pileGavList"
                :key="item.id"
                :label="item.name"
                :value="item.supplier_code"
              ></el-option>
            </el-select>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="4">
            <span></span>
            <span>快慢充类型：</span>
          </el-col>
          <el-col :span="8">
            <el-select
              :disabled="ifdis == true"
              v-model="charge_type"
              clearable
              placeholder="请选择快慢充类型"
            >
              <el-option
                v-for="item in chargeTypeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="4">
            <span></span>
            <span>交直流类型：</span>
          </el-col>
          <el-col :span="8">
            <el-select
              :disabled="ifdis == true"
              v-model="AC_DC_Type"
              clearable
              placeholder="请选择交直流类型"
            >
              <el-option
                v-for="item in AC_DC_TypeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="4">
            <span></span>
            <span>充电桩型号：</span>
          </el-col>
          <el-col :span="8">
            <el-select
              :disabled="ifdis == true"
              v-model="changePileType"
              clearable
              placeholder="请选择充电桩型号"
            >
              <el-option
                v-for="item in changePileTypeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="4">
            <span></span>
            <span>单双枪类型：</span>
          </el-col>
          <el-col :span="8">
            <el-select
              :disabled="ifdis == true"
              v-model="no_gun"
              clearable
              @change="changeNoGun"
              placeholder="请选择单双枪类型"
            >
              <el-option
                v-for="item in noGunList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="4">
            <span></span>
            <span>组织机构代码：</span>
          </el-col>
          <el-col :span="8">
            <el-input
              :disabled="ifdis == true"
              v-model="organizationCode"
              clearable
              placeholder="请输入数字、英文："
            ></el-input>
          </el-col>
          <el-col :span="4">
            <span></span>
            <span>设备型号：</span>
          </el-col>
          <el-col :span="8">
            <el-input
              :disabled="ifdis == true"
              v-model="equipmentType"
              clearable
              placeholder="请输入设备型号："
            ></el-input>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="4">
            <span></span>
            <span>设备生产商名称：</span>
          </el-col>
          <el-col :span="8">
            <el-input
              :disabled="ifdis == true"
              v-model="organizationName"
              clearable
              placeholder="请输入设备生产商名称："
            ></el-input>
          </el-col>
          <el-col :span="4">
            <span></span>
            <span>充电设备总功率：</span>
          </el-col>
          <el-col :span="8">
            <el-input
              :disabled="ifdis == true"
              v-model="equipmentTotalPower"
              clearable
              placeholder="请输入纯数字："
            ></el-input>
          </el-col>
        </el-row>

        <div class="line"></div>

        <el-row>
          <el-col :span="4">
            <span></span>
            <span>设备接口名称：</span>
          </el-col>
          <el-col :span="8">
            <el-input
              :disabled="ifdis == true"
              v-model="deviceInterfaceName"
              clearable
              placeholder="请输入设备接口名称："
            ></el-input>
          </el-col>
          <el-col :span="4">
            <span></span>
            <span>国家标准：</span>
          </el-col>
          <el-col :span="8">
            <el-select
              :disabled="ifdis == true"
              v-model="nationalStandard"
              clearable
              placeholder="请选择国家标准："
            >
              <el-option
                v-for="item in nationalStandardList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="4">
            <span></span>
            <span>设备接口类型：</span>
          </el-col>
          <el-col :span="8">
            <el-select
              :disabled="ifdis == true"
              v-model="deviceInterfaceType"
              clearable
              placeholder="请选择设备接口类型："
            >
              <el-option
                v-for="item in deviceInterfaceTypeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="4">
            <span></span>
            <span>额定电流(A)：</span>
          </el-col>
          <el-col :span="8">
            <el-input
              :disabled="ifdis == true"
              v-model="ratedCurrent"
              clearable
              placeholder="请输入纯数字："
            ></el-input>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="4">
            <span></span>
            <span>额定电压(V)：</span>
          </el-col>
          <el-col :span="8">
            <el-input
              :disabled="ifdis == true"
              style="width: 49%"
              v-model="ratedVTop"
              clearable
              placeholder="上限、纯数字："
            ></el-input>
            <el-input
              :disabled="ifdis == true"
              style="width: 49%"
              v-model="ratedVBottom"
              clearable
              placeholder="下限、纯数字："
            ></el-input>
          </el-col>
          <el-col :span="4">
            <span></span>
            <span>额定功率(KWh)：</span>
          </el-col>
          <el-col :span="8">
            <el-input
              :disabled="ifdis == true"
              v-model="ratedPower"
              clearable
              placeholder="请输入纯数字："
            ></el-input>
          </el-col>
        </el-row>

        <div v-if="towNumOpen">
          <div class="line"></div>
          <el-row>
            <el-col :span="4">
              <span></span>
              <span>设备接口名称：</span>
            </el-col>
            <el-col :span="8">
              <el-input
                :disabled="ifdis == true"
                v-model="deviceInterfaceName1"
                clearable
                placeholder="请输入设备接口名称："
              ></el-input>
            </el-col>
            <el-col :span="4">
              <span></span>
              <span>国家标准：</span>
            </el-col>
            <el-col :span="8">
              <el-select
                :disabled="ifdis == true"
                v-model="nationalStandard1"
                clearable
                placeholder="请选择国家标准："
              >
                <el-option
                  v-for="item in nationalStandardList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="4">
              <span>*</span>
              <span>设备接口类型：</span>
            </el-col>
            <el-col :span="8">
              <el-select
                :disabled="ifdis == true"
                v-model="deviceInterfaceType1"
                clearable
                placeholder="请选择设备接口类型："
              >
                <el-option
                  v-for="item in deviceInterfaceTypeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-col>
            <el-col :span="4">
              <span>*</span>
              <span>额定电流(A)：</span>
            </el-col>
            <el-col :span="8">
              <el-input
                :disabled="ifdis == true"
                v-model="ratedCurrent1"
                clearable
                placeholder="请输入纯数字："
              ></el-input>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="4">
              <span>*</span>
              <span>额定电压(V)：</span>
            </el-col>
            <el-col :span="8">
              <el-input
                :disabled="ifdis == true"
                style="width: 49%"
                v-model="ratedVTop1"
                clearable
                placeholder="上限、纯数字："
              ></el-input>
              <el-input
                :disabled="ifdis == true"
                style="width: 49%"
                v-model="ratedVBottom1"
                clearable
                placeholder="下限、纯数字："
              ></el-input>
            </el-col>
            <el-col :span="4">
              <span>*</span>
              <span>额定功率(KWh)：</span>
            </el-col>
            <el-col :span="8">
              <el-input
                :disabled="ifdis == true"
                v-model="ratedPower1"
                clearable
                placeholder="请输入纯数字："
              ></el-input>
            </el-col>
          </el-row>
        </div>

        <div class="camera-button" v-if="hiddlethis">
          <el-button class="camera-cancel" @click="cancelClick()"
            >取消</el-button
          >
          <el-button class="camera-confirm" @click="cameraConfirmClick1()"
            >确认</el-button
          >
        </div>
      </div>
    </el-dialog>

    <!-- 供应商管理 -->
    <el-dialog
      :visible.sync="merchantsM"
      customClass="camera-dialog"
      width="820px"
      :close-on-click-modal="false"
    >
      <p class="title">供应商管理</p>
      <div class="line"></div>
      <el-button class="addMerchants" @click="newaddmerchant"
        >新增供应商</el-button
      >
      <div>
        <div class="camera-equ-table">
          <el-table
            :header-cell-style="{
              background: '#f3f3f3',
              color: '#323232',
              height: '50px',
            }"
            :data="tableData1"
            border
            style="width: 100%"
          >
            <el-table-column prop="name" label="供应商名称">
              <template slot-scope="scope">{{
                scope.row.name | defaultValFilter
              }}</template>
            </el-table-column>
            <el-table-column prop="supplier_code" label="供应商代码">
              <template slot-scope="scope">{{
                scope.row.supplier_code | defaultValFilter
              }}</template>
            </el-table-column>
            <el-table-column prop="create_time" label="创建时间">
              <template slot-scope="scope">{{
                scope.row.create_time | defaultValFilter
              }}</template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button class="btn edit" @click="editmerchant(scope.row)"
                  >编辑</el-button
                >
                <el-button class="btn delete" @click="deleteCamera1(scope.row)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pagination">
          <el-pagination
            background
            layout="prev, pager, next"
            :page-size="10"
            :total="merchantstotalNum"
          >
          </el-pagination>
        </div>

        <!-- <div class="camera-button">
          <el-button class="camera-cancel" @click="cancelClick()"
            >取消</el-button
          >
          <el-button class="camera-confirm" @click="cameraConfirmClick()"
            >确认</el-button
          >
        </div> -->
      </div>
    </el-dialog>

    <!-- 新增/编辑供应商 -->
    <el-dialog
      :visible.sync="merchantsMM"
      customClass="camera-dialog"
      width="850px"
      :close-on-click-modal="false"
    >
      <p class="title">{{ merchantTitle }}</p>
      <div class="line"></div>
      <div>
        <el-row>
          <el-col :span="8">
            <span>*</span>
            <span>供应商名称：</span>
          </el-col>
          <el-col :span="10">
            <el-input
              v-model="merchantsNN"
              clearable
              placeholder="请输入供应商名称"
            ></el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <span>*</span>
            <span>供应商代码：</span>
          </el-col>
          <el-col :span="10">
            <el-input
              v-model="merchantscode"
              clearable
              placeholder="请输入供应商代码"
            ></el-input>
          </el-col>
        </el-row>
        <div class="camera-button">
          <el-button class="camera-cancel" @click="ncancelClick()"
            >取消</el-button
          >
          <el-button class="camera-confirm" @click="cameraConfirmClick()"
            >确认</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: ["provincesName", "cityName", "stationId"],
  data() {
    return {
      ifdis: false,
      editmerchantId: "",
      editmerchantcode: 0,
      merchantscode: "",
      tableData1: [],
      ratedPower1: "",
      ratedVBottom1: "",
      ratedVTop1: "",
      ratedCurrent1: "",
      deviceInterfaceType1: "",
      nationalStandard1: "",
      deviceInterfaceName1: "",
      equipmentTotalPower: "",
      changePileTypeList: [
        // {
        //   value: "1",
        //   label: "7KW",
        // },
        // {
        //   value: "2",
        //   label: "30KW",
        // },
        // {
        //   value: "3",
        //   label: "60KW",
        // },
        // {
        //   value: "4",
        //   label: "40KW",
        // },
        // {
        //   value: "5",
        //   label: "42KW",
        // },
        // {
        //   value: "6",
        //   label: "80KW",
        // },
        // {
        //   value: "7",
        //   label: "84KW",
        // },
        // {
        //   value: "8",
        //   label: "90KW",
        // },
        // {
        //   value: "9",
        //   label: "120KW",
        // },
        // {
        //   value: "10",
        //   label: "240KW",
        // },
      ],
      organizationName: "",
      merchantTitle: "新增供应商",
      merchantsNN: "",
      hiddlethis: true,
      towNumOpen: false,
      merchantsMM: false,
      merchantsM: false,
      addmerchant: false,
      ratedVTop: "",
      ratedVBottom: "",
      ratedPower: "",
      deviceInterfaceTypeList: [
        {
          value: "1",
          label: "家用插座（模式2)",
        },
        {
          value: "2",
          label: "交流接口插座（模式3, 连接方式B)",
        },
        {
          value: "3",
          label: "交流接口插头（带枪线，模式3, 连接方式C)",
        },
        {
          value: "4",
          label: "直流接口枪头（带枪线，模式4）",
        },
        {
          value: "5",
          label: "无线充电座",
        },
        {
          value: "6",
          label: "其他",
        },
      ],
      deviceInterfaceType: "",
      ratedCurrent: "",
      nationalStandard: "",
      nationalStandardList: [
        {
          value: "2011",
          label: "2011",
        },
        {
          value: "2015",
          label: "2015",
        },
      ],
      templateName: "",
      charge_type: "",
      chargeTypeList: [
        {
          value: "1",
          label: "快充",
        },
        {
          value: "2",
          label: "慢充",
        },
      ],
      AC_DC_Type: "",
      AC_DC_TypeList: [
        {
          value: "AC",
          label: "交流设备",
        },
        {
          value: "DC",
          label: "直流设备",
        },
        {
          value: "DC/AC",
          label: "交直流一体设备",
        },
        {
          value: "WIRELESS",
          label: "无线设备",
        },
        {
          value: "OTHER",
          label: "其他",
        },
      ],
      changePileType: "",
      no_gun: "",
      noGunList: [
        {
          value: "1",
          label: "单枪",
        },
        {
          value: "2",
          label: "双枪",
        },
      ],
      organizationCode: "",
      equipmentType: "",
      deviceInterfaceName: "",
      pileGavList: [],
      pileGav: "",
      addCameraDialog: false,
      cameraTitle: "新建模板",
      tableData: [],
      // 页面需要展现的数据
      // 页面展现条数
      datanum: 10,
      // 开始页数
      startnum: 0,
      // 结束页数
      endnum: 1,
      // 一共多少页
      totalNum: 0,
      merchantstotalNum: 0,
      cameraProvince: "",
      cameraProvinceList: [],
      cameraCity: "",
      cameraCityList: [],
      cameraStation: "",

      dialogNum: 0,
      camera_id: "",
      serial_no: "",
      nvr_serial_no: "",
      video_link: "",
      cameraId: "",
      newPrivilege: 1, //新建
      editPrivilege: 1, //编辑
      deletePrivilege: 1, //删除
    };
  },
  mounted() {
    this.$nextTick(function () {
      let role = [];
      role = this.$store.state.role;
      for (let i in role) {
        if (role[i].view_name == "场站管理") {
          for (let j in role[i].chlid) {
            if (role[i].chlid[j].view_name == "设备管理") {
              for (let m in role[i].chlid[j].method) {
                if (role[i].chlid[j].method[m].method_name == "新建摄像头") {
                  this.newPrivilege = 0;
                } else if (
                  role[i].chlid[j].method[m].method_name == "编辑摄像头"
                ) {
                  this.editPrivilege = 0;
                } else if (
                  role[i].chlid[j].method[m].method_name == "删除摄像头"
                ) {
                  this.deletePrivilege = 0;
                }
              }
            }
          }
        }
      }
      this.getpowerList()
      this.getCameraList();
      this.getmerchantsList();
    });
  },
  watch: {
    stationId: function (newVal, oldVal) {
      this.totalNum = 0;
      this.startnum = 0;
      this.endnum = 1;
      this.getCameraList(this.provincesName, this.cityName, this.stationId);
    },
  },
  methods: {
    getpowerList(){
      let params={
        uid:localStorage.getItem("uid"),
        token:localStorage.getItem("token"),
        action:"getChargerPowerLists"
      }
      this.$api({
        method:"POST",
        url:"/api.php/deviceManage/Index",
        data:params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      }).then(res=>{
        res.data.list.map(item=>{
          this.changePileTypeList.push({value:item.id,label:item.powers+"KW"})
        })
      })
    },
    currentChange(data) {
      this.endnum = data;
      this.startnum = data - 1;
    },
    getmerchantsList() {
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action: "listsSupplier",
      };
      this.$api({
        method: "post",
        url: "/api.php/supplierManage/Index",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      }).then((res) => {
        if (res.data.code == 1) {
          this.pileGavList = res.data.list;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    getCameraList() {
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action: "listsChargeTemp",
      };
      this.$api({
        method: "post",
        url: "/api.php/deviceTemplate/Index",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.tableData = su.data.data.lists;
            this.totalNum = this.tableData.length;
          } else {
            this.$message.warning(su.data.message);
          }
        })
        .catch((err) => {});
    },
    addCameraClick(num) {
      this.addCameraDialog = true;
      this.cameraTitle = "新建摄像设备";
      this.getProvinces();
      this.dialogNum = num;
    },
    getProvinces() {
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
      };
      this.$api({
        method: "post",
        url: "/api.php/Currency/get_provinces",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.cameraProvinceList = su.data.list;
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          } else if (su.data.code == 900) {
          } else {
            this.$message.warning(su.data.message);
          }
        })
        .catch((err) => {});
    },
    cancelClick() {
      this.addCameraDialog = false;
      this.merchantsM = false;
      //清空添加模板列表
      this.templateName = "";
      this.pileGav = "";
      this.charge_type = "";
      this.AC_DC_Type = "";
      this.changePileType = "";
      this.no_gun = "";
      this.organizationCode = "";
      this.equipmentType = "";
      this.organizationName = "";
      this.equipmentTotalPower = "";
      this.deviceInterfaceName = "";
      this.nationalStandard = "";
      this.deviceInterfaceType = "";
      this.ratedCurrent = "";
      this.ratedVTop = "";
      this.ratedVBottom = "";
      this.ratedPower = "";
      this.deviceInterfaceName1 = "";
      this.nationalStandard1 = "";
      this.deviceInterfaceType1 = "";
      this.ratedCurrent1 = "";
      this.ratedVTop1 = "";
      this.ratedVBottom1 = "";
      this.ratedPower1 = "";
    },
    ncancelClick() {
      this.merchantsMM = false;
      this.merchantsNN = "";
      this.merchantscode = "";
    },
    cameraConfirm() {
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action: "addCamera",
        station_id: this.cameraStation,
        camera_id: this.camera_id,
        serial_no: this.serial_no,
        nvr_serial_no: this.nvr_serial_no,
        video_link: this.video_link,
      };
      this.$api({
        method: "post",
        url: "/api.php/DeviceManage/index",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.$message.success(su.data.message);
            this.addCameraDialog = false;
            this.totalNum = 0;
            this.startnum = 0;
            this.endnum = 1;
            this.getCameraList();
            this.$emit("listenToChildEvent", "空");
            this.cameraProvince = "";
            this.cameraCity = "";
            this.cameraCityList = [];
            this.cameraStation = "";
            this.dialogNum = 0;
            this.camera_id = "";
            this.serial_no = "";
            this.nvr_serial_no = "";
            this.video_link = "";
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          } else if (su.data.code == 900) {
          } else {
            this.$message.warning(su.data.message);
          }
        })
        .catch((err) => {});
    },
    editCamera(row, num1) {
      this.templateName = "";
      this.pileGav = "";
      this.charge_type = "";
      this.AC_DC_Type = "";
      this.changePileType = "";
      this.no_gun = "";
      this.organizationCode = "";
      this.equipmentType = "";
      this.organizationName = "";
      this.equipmentTotalPower = "";

      this.deviceInterfaceName = "";
      this.nationalStandard = "";
      this.deviceInterfaceType = "";
      this.ratedCurrent = "";
      this.ratedVTop = "";
      this.ratedVBottom = "";
      this.ratedPower = "";

      this.deviceInterfaceName1 = "";
      this.nationalStandard1 = "";
      this.deviceInterfaceType1 = "";
      this.ratedCurrent1 = "";
      this.ratedVTop1 = "";
      this.ratedVBottom1 = "";
      this.ratedPower1 = "";

      if (row.no_gun == 2) {
        this.towNumOpen = true;
      } else if (row.no_gun == 1) {
        this.towNumOpen = false;
      }
      this.addCameraDialog = true;
      if (num1 && num1 == 2) {
        this.hiddlethis = false;
        this.cameraTitle = "设备详情";
        this.ifdis = true;
      } else {
        this.hiddlethis = true;
        this.cameraTitle = "编辑桩模板";
        this.ifdis = false;
      }
      this.cameraId = row.id;
      let backData = {};
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action: "detailChargeTemp",
        id: this.cameraId,
      };
      this.$api({
        method: "post",
        url: "/api.php/deviceTemplate/Index",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      }).then((res) => {
        if (res.data.code == 1) {
          console.log(res.data.list);
          backData = res.data.list;
          this.templateName = backData.template_name;
          this.pileGav = backData.maker;
          this.charge_type = backData.charge_type;
          this.AC_DC_Type = backData.type;
          this.changePileType = backData.model;
          this.no_gun = backData.no_gun;
          this.organizationCode = backData.manufacturer_sn;
          this.equipmentType = backData.equipment_model;
          this.organizationName = backData.manufacturer_name;
          this.equipmentTotalPower = backData.equipment_power;

          for (let i in backData.gun) {
            if (backData.gun[i].gun_no == 1) {
              this.deviceInterfaceName = backData.gun[i].connector_name;
              this.nationalStandard = backData.gun[i].national_standard;
              this.deviceInterfaceType = backData.gun[i].connector_type;
              this.ratedCurrent = backData.gun[i].rated_current;
              this.ratedVTop = backData.gun[i].rated_voltage_upper_limit;
              this.ratedVBottom = backData.gun[i].rated_voltage_lower_limit;
              this.ratedPower = backData.gun[i].rated_power;
            } else if (backData.gun[i].gun_no == 2) {
              this.deviceInterfaceName1 = backData.gun[i].connector_name;
              this.nationalStandard1 = backData.gun[i].national_standard;
              this.deviceInterfaceType1 = backData.gun[i].connector_type;
              this.ratedCurrent1 = backData.gun[i].rated_current;
              this.ratedVTop1 = backData.gun[i].rated_voltage_upper_limit;
              this.ratedVBottom1 = backData.gun[i].rated_voltage_lower_limit;
              this.ratedPower1 = backData.gun[i].rated_power;
            }
          }
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    cameraConfirmClick() {
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),

        name: this.merchantsNN,
        supplier_code: this.merchantscode,
      };

      if (this.editmerchantcode == 0) {
        params.action = "addSupplier";
      } else if (this.editmerchantcode == 1) {
        params.action = "editSupplier";
        params.id = this.editmerchantId;
      }

      this.$api({
        method: "post",
        url: "/api.php/supplierManage/Index",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      }).then((res) => {
        if (res.data.code == 1) {
          this.merchantsMM = false;
          this.addMerchants();
          this.merchantsNN = "";
          this.merchantscode = "";
          this.$message.success(res.data.message);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    deleteCamera(row) {
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action: "deleteChargeTemp",
        id: row.id,
      };
      this.$confirm("确定删除", "删除", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "",
      })
        .then(() => {
          this.$api({
            method: "post",
            url: "/api.php/deviceTemplate/Index",
            data: params,
            transformRequest: [
              (data) => {
                let ret = "";
                for (let it in data) {
                  ret +=
                    encodeURIComponent(it) +
                    "=" +
                    encodeURIComponent(data[it]) +
                    "&";
                }
                return ret;
              },
            ],
          })
            .then((su) => {
              if (su.data.code == 1) {
                this.$message.success(su.data.message);
                this.getCameraList();
              } else {
                this.$message.error(su.data.message);
              }
            })
            .catch((err) => {});
        })
        .catch(() => {});
    },
    deleteCamera1(row) {
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action: "deleteSupplier",
        id: row.id,
      };
      this.$confirm("确定删除", "删除", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.$api({
            method: "post",
            url: "/api.php/supplierManage/Index",
            data: params,
            transformRequest: [
              (data) => {
                let ret = "";
                for (let it in data) {
                  ret +=
                    encodeURIComponent(it) +
                    "=" +
                    encodeURIComponent(data[it]) +
                    "&";
                }
                return ret;
              },
            ],
          })
            .then((su) => {
              if (su.data.code == 1) {
                this.$message.success(su.data.message);
                this.addMerchants();
              } else {
                this.$message.error(su.data.message);
              }
            })
            .catch((err) => {});
        })
        .catch(() => {});
    },
    addMerchants() {
      this.merchantsM = true;
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action: "listsSupplier",
      };
      this.$api({
        method: "post",
        url: "/api.php/supplierManage/Index",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      }).then((res) => {
        if (res.data.code == 1) {
          this.tableData1 = res.data.list;
          this.merchantstotalNum = res.data.list.length;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    addPileTemplate() {
      this.getmerchantsList();
      this.hiddlethis=true
      this.ifdis = false;
      this.addCameraDialog = true;
      this.cameraTitle = "新建桩模板";
      //清空列表
      this.templateName = "";
      this.pileGav = "";
      this.charge_type = "";
      this.AC_DC_Type = "";
      this.changePileType = "";
      this.no_gun = "";
      this.organizationCode = "";
      this.equipmentType = "";
      this.organizationName = "";
      this.equipmentTotalPower = "";
      this.deviceInterfaceName = "";
      this.nationalStandard = "";
      this.deviceInterfaceType = "";
      this.ratedCurrent = "";
      this.ratedVTop = "";
      this.ratedVBottom = "";
      this.ratedPower = "";
      this.deviceInterfaceName1 = "";
      this.nationalStandard1 = "";
      this.deviceInterfaceType1 = "";
      this.ratedCurrent1 = "";
      this.ratedVTop1 = "";
      this.ratedVBottom1 = "";
      this.ratedPower1 = "";
    },
    cameraConfirmClick1() {
      let deviceInterfaceName = [];
      let deviceInterfaceType = [];
      let ratedVTop = [];
      let ratedVBottom = [];
      let ratedCurrent = [];
      let ratedPower = [];
      let nationalStandard = [];
      if (this.no_gun == 1) {
        deviceInterfaceName = [this.deviceInterfaceName];
        deviceInterfaceType = [this.deviceInterfaceType];
        ratedVTop = [this.ratedVTop];
        ratedVBottom = [this.ratedVBottom];
        ratedCurrent = [this.ratedCurrent];
        ratedPower = [this.ratedPower];
        nationalStandard = [this.nationalStandard];
      } else if (this.no_gun == 2) {
        deviceInterfaceName = [
          this.deviceInterfaceName,
          this.deviceInterfaceName1,
        ];
        deviceInterfaceType = [
          this.deviceInterfaceType,
          this.deviceInterfaceType1,
        ];
        ratedVTop = [this.ratedVTop, this.ratedVTop1];
        ratedVBottom = [this.ratedVBottom, this.ratedVBottom1];
        ratedCurrent = [this.ratedCurrent, this.ratedCurrent1];
        ratedPower = [this.ratedPower, this.ratedPower1];
        nationalStandard = [this.nationalStandard, this.nationalStandard1];
      }

      if (isEmpty(this.templateName)) {
        this.$message.warning("请输入模板名称！");
        return;
      } else if (isEmpty(this.pileGav)) {
        this.$message.warning("请选择桩供应商！");
        return;}
      // } else if (isEmpty(this.charge_type)) {
      //   this.$message.warning("请选择快慢充类型！");
      //   return;
      // } else if (isEmpty(this.AC_DC_Type)) {
      //   this.$message.warning("请选择交直流类型！");
      //   return;
      // } else if (isEmpty(this.changePileType)) {
      //   this.$message.warning("请选择充电桩型号！");
      //   return;
      // } else if (isEmpty(this.no_gun)) {
      //   this.$message.warning("请选择单双枪类型！");
      //   return;
      // } else if (isEmpty(this.organizationCode)) {
      //   this.$message.warning("请输入数字、英文");
      //   return;
      // } else if (isEmpty(this.equipmentType)) {
      //   this.$message.warning("请输入设备型号！");
      //   return;
      // } else if (isEmpty(this.organizationName)) {
      //   this.$message.warning("请输入设备生产商名称！");
      //   return;
      // } else if (isEmpty(this.equipment_sn)) {
      //   this.$message.warning("请输入设备唯一编码！");
      //   return;
      // } else if (isEmpty(this.equipmentTotalPower)) {
      //   this.$message.warning("充电设备总功率!");
      //   return;
      // } else if (!longrg.test(this.deviceInterfaceName)) {
      //   this.$message.warning("请输入设备接口名称!");
      //   return;
      // } else if (isEmpty(this.nationalStandard)) {
      //   this.$message.warning("请选择国家标准!");
      //   return;
      // } else if (!latreg.test(this.deviceInterfaceType)) {
      //   this.$message.warning("请选择设备接口类型!");
      //   return;
      // } else if (isEmpty(this.ratedCurrent)) {
      //   this.$message.warning("请输额定电流!");
      //   return;
      // } else if (isEmpty(this.ratedVTop)) {
      //   this.$message.warning("额定电压上限!");
      //   return;
      // } else if (isEmpty(this.ratedVBottom)) {
      //   this.$message.warning("额定电压下限！");
      //   return;
      // } else if (isEmpty(this.ratedPower)) {
      //   this.$message.warning("请输入额定功率!");
      //   return;
      // }
      // if (this.towNumOpen) {
      //   if (isEmpty(this.deviceInterfaceName1)) {
      //     this.$message.warning("请输入设备接口名称2!");
      //     return;
      //   } else if (isEmpty(this.nationalStandard1)) {
      //     this.$message.warning("请选择国家标准2!");
      //     return;
      //   } else if (isEmpty(this.deviceInterfaceType1)) {
      //     this.$message.warning("请选择设备接口类型2!");
      //     return;
      //   } else if (isEmpty(this.ratedCurrent1)) {
      //     this.$message.warning("请输入额定电流2！");
      //     return;
      //   } else if (isEmpty(this.ratedVTop1)) {
      //     this.$message.warning("请输入额定电压上限2！");
      //     return;
      //   } else if (isEmpty(this.ratedVBottom1)) {
      //     this.$message.warning("额定电压下限2！");
      //     return;
      //   } else if (isEmpty(this.ratedPower1)) {
      //     this.$message.warning("请输入额定功率2!");
      //     return;
      //   }
      // }

      let params = {
        token: localStorage.getItem("token"),
        uid: localStorage.getItem("uid"),
        template_name: this.templateName,
        type: this.AC_DC_Type,
        charge_type: this.charge_type,
        // serial_no:
        no_gun: this.no_gun,
        // installed_date:
        maker: this.pileGav,
        model: this.changePileType,
        // special_use:
        manufacturer_sn: this.organizationCode,
        manufacturer_name: this.organizationName,
        equipment_model: this.equipmentType,
        equipment_power: this.equipmentTotalPower,

        connector_name: deviceInterfaceName,
        connector_type: deviceInterfaceType,
        rated_voltage_upper_limit: ratedVTop,
        rated_voltage_lower_limit: ratedVBottom,
        rated_current: ratedCurrent,
        // park_no:
        rated_power: ratedPower,
        // latitude:
        // longitude:
        // equipment_sn:
        national_standard: nationalStandard,
      };
      if (this.cameraTitle == "新建桩模板") {
        params.action = "addChargeTemp";
      } else if (this.cameraTitle == "编辑桩模板") {
        params.action = "editChargeTemp";
        params.id = this.cameraId;
      }
      this.$api({
        method: "post",
        url: "/api.php/deviceTemplate/Index",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      }).then((res) => {
        if (res.data.code == 1) {
          this.getCameraList();
          this.$message.success(res.data.message);
          this.addCameraDialog = false;
          //创建成功清空列表
          this.templateName = "";
          this.pileGav = "";
          this.charge_type = "";
          this.AC_DC_Type = "";
          this.changePileType = "";
          this.no_gun = "";
          this.organizationCode = "";
          this.equipmentType = "";
          this.organizationName = "";
          this.equipmentTotalPower = "";
          this.deviceInterfaceName = "";
          this.nationalStandard = "";
          this.deviceInterfaceType = "";
          this.ratedCurrent = "";
          this.ratedVTop = "";
          this.ratedVBottom = "";
          this.ratedPower = "";
          this.deviceInterfaceName1 = "";
          this.nationalStandard1 = "";
          this.deviceInterfaceType1 = "";
          this.ratedCurrent1 = "";
          this.ratedVTop1 = "";
          this.ratedVBottom1 = "";
          this.ratedPower1 = "";
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    changeNoGun(val) {
      if (val == 2) {
        this.towNumOpen = true;
      } else {
        this.towNumOpen = false;
      }
    },
    editmerchant(row) {
      this.editmerchantId = row.id;
      this.editmerchantcode = 1;
      this.merchantsMM = true;
      this.merchantTitle = "编辑供应商";
      this.merchantsNN = row.name;
      this.merchantscode = row.supplier_code;
    },
    newaddmerchant() {
      this.editmerchantcode = 0;
      this.merchantsMM = true;
      this.merchantTitle = "新增供应商";
    },
  },
};
</script>

<style scoped lang="scss">
.camera-equ {
  .camera-equ-top {
    .btn {
      border: none;
      color: #ffffff;
    }
    .addMerchants {
      float: right;
      margin-right: 20px;
      background-color: #0177bd;
      color: white;
    }
    .addPileTemplate {
      float: right;
      margin-right: 10px;
      background-color: #f15500;
      color: white;
    }
  }
  .camera-equ-table {
    margin-top: 24px;
    width: 98%;
    margin-left: 1%;
    .btn {
      width: 54px;
      height: 26px;
      color: #ffffff;
      border: none;
      padding: 0;
      text-align: center;
      font-size: 12px;
    }
    .edit {
      background-color: #0171bb;
    }
    .edit.active {
      background-color: #a5a5a5;
    }
    .delete {
      background-color: #00b270;
    }
    .delete.active {
      background-color: #a5a5a5;
    }
    .rate {
      background-color: #f15500;
    }
    .disabled {
      background-color: #01a2b4;
    }
    .el-button + .el-button {
      margin-left: 5px;
    }
  }
  .pagination {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
    margin-right: 18px;
  }
  .camera-dialog {
    position: relative;
    overflow-x: hidden;
    .title {
      font-size: 18px;
      position: absolute;
      left: 16px;
      top: 16px;
      color: #0171bd;
    }
    .line {
      width: calc(100% + 40px);
      margin-left: -20px;
      margin-right: -20px;
      height: 1px;
      margin-top: 8px;
      background-color: #eaeaea;
      margin-bottom: 8px;
    }

    .el-row {
      margin-bottom: 8px;
      .el-col {
        text-align: right;
        line-height: 40px;
        span:first-child {
          color: red;
        }
        .el-select {
          width: 100%;
        }
      }
    }
    div {
      .addMerchants {
        float: right;
        background-color: #f15500;
        color: white;
        margin: 0 10px 5px 0;
      }
    }

    .camera-button {
      margin-top: 40px;
      .camera-cancel {
        width: 20%;
        background-color: #0071bd;
        color: #ffffff;
        border: none;
        height: 50px;
      }
      .camera-confirm {
        width: 20%;
        background-color: #02b36f;
        color: #ffffff;
        border: none;
        height: 50px;
      }
    }
  }
}
</style>
<style lang="scss">
.camera-equ .el-table--enable-row-hover .el-table__body tr:hover > td .edit {
  background-color: #409eff;
}
</style>


// WEBPACK FOOTER //
// src/components/stationManagement/pileTemplate.vue